import React from "react";

const ReferWrap = ({ children }) => {
  return (
    <section className="bg-input-color dark:bg-base-dark p-[5px] rounded-[5px] text-dark-gray-text">
      {children}
    </section>
  );
};

export default ReferWrap;
